import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../Common/ChartsDynamicColor";
import { getAdminDealStatus } from "http/UAM/userDashboardWidget.helper";
import { startCase } from "lodash";
import PropTypes from 'prop-types';
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";
import { decryptedValue } from "common/utility";

const DealStatus = ({ dataColors, userType }) => {
  const apexsalesAnalyticsChartColors = getChartColorsArray(dataColors);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [dealStatusData, setDealStatusData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)
  const user = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    if (userType === "admin" || userType == "admin_operations" || userType == "partner" || userType == "RM" || userType == "FI_RM" || userType == "program_manager" || userType == "reporting_manager" || userType == "program Team") {
      getAdminDealStatus({ productType: selectedFilter, user: user }).then((res) => {
        setDealStatusData(res.data);
        if (res.data['ApprovedByCIAdmin'] == 0 && res.data['No of Deals in Draft'] == 0 && res.data['No of Deals in Query'] == 0 && res.data['Pending For E-Signing'] == 0 && res.data['Sent To Financier'] == 0 && res.data['Submitted by Partner'] == 0 && res.data['interestShownByFI'] == 0 && res.data['totalNoOfDeals'] == 0) {
          setShowStatus(false)
        } else {
          setShowStatus(true)
        }
      });
    }else{
      setShowStatus(false)
    }
  }, [selectedFilter, userType]);

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const labels = Object.keys(dealStatusData).filter(
    (key) => key !== "totalNoOfDeals"
  );
  const values = labels.map(label => dealStatusData[label])

  const series = values;
  const options = {
    labels: labels.map((i) => startCase(i)),
    colors: apexsalesAnalyticsChartColors,
    legend: { show: false },
    dataLabels: {
      enabled: true,
      formatter: function ({ seriesIndex, w }) {
        return w?.globals?.series[seriesIndex];
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
          size: "65%",
        },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        show: true,
        formatter: (value) => {
          return `${value}`;
        },
      },
    },
    annotations: {
      position: "center",
      yaxis: [
        {
          y: 0,
          y2: 1,
          label: {
            text: "Deal Status",
            style: {
              fontSize: "20px",
              color: "#333",
              background: "transparent",
            },
          },
        },
      ],
    },
  };

  return (
    <Card>
      {showStatus ? <CardBody>
        <Row>
          <Col lg='6' sm='12'>
            <h4 className="card-title mb-2">
              {(userType === "admin" || userType === "admin_operations" || userType == "partner" || userType == "RM" || userType == "FI_RM" || userType == "program_manager" || userType == "reporting_manager" || userType == "program Team") ? "Deal Status" : "Total deals summary"}
            </h4>
          </Col>
          <Col lg='6' sm='12'
            className="mb-2"
          >
            <select
              className="form-select"
              id="filterOptions"
              value={selectedFilter}
              onChange={handleFilterChange}
            >
              <option value="All">All</option>
              <option value="Working Capital">Working Capital</option>
              <option value="Term Loan">Term Loan</option>
              <option value="Others(Lease)">Others(Lease)</option>
              <option value="Structured Finance">Structured Finance</option>
              {/* Add more options for different filter options */}
            </select>
          </Col>
        </Row>

        {/* Chart component */}
        <div className="d-flex align-items-center  flex-column flex-md-row">
          <div style={{ position: "relative" }}>
            <div id="donut-chart-deal-status">
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height={312}
                width={350}
                className="apex-charts"
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <span style={{ fontSize: "20px" }}>
                  {dealStatusData["totalNoOfDeals"]}
                </span>
                <span style={{ fontSize: "14px" }}>Total Deals</span>
              </div>
            </div>
          </div>
          <Row>
            {labels.map((label, index) => {
              return (
                <Col
                  key={label}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <i
                    style={{ color: apexsalesAnalyticsChartColors[index] }}
                    className={`mdi mdi-circle ${apexsalesAnalyticsChartColors[index]} me-1`}
                  />
                  <p
                    className="mb-2 text-truncate"
                    title={label}
                    style={{
                      width: "200px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    {startCase(label)}
                  </p>
                </Col>
              );
            })}
          </Row>

        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="We couldn't find the Deal Status" />}
    </Card>
  );
};

DealStatus.propTypes = {
  dataColors: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
}


export default DealStatus;
